import { render, staticRenderFns } from "./ClientNew.vue?vue&type=template&id=35cc4855&scoped=true&"
import script from "./ClientNew.vue?vue&type=script&lang=js&"
export * from "./ClientNew.vue?vue&type=script&lang=js&"
import style0 from "./ClientNew.vue?vue&type=style&index=0&id=35cc4855&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cc4855",
  null
  
)

export default component.exports